import { Feature, Maybe } from '../graphql.generated';
import getListingFeatures from './getListingFeatures';
import { fontGroups } from '@zoopla-eng/zds/themes';
import {
    LivingRoomMedium,
    BathroomMedium,
    BedroomMedium
} from '@zoopla-eng/zds/icons';
import {
    featureListItemStyle,
    featureListStyle
} from './ListingFeatureList.styles.css';

type ListingFeaturesProps = {
    features?: Maybe<Array<Maybe<Feature>>>;
    noSpacing?: boolean;
};

const featureMap = new Map([
    ['chair', <LivingRoomMedium />],
    ['bath', <BathroomMedium />],
    ['bed', <BedroomMedium />]
]);

const ListingFeatureList = ({ features, noSpacing }: ListingFeaturesProps) => {
    if (!features?.length) {
        return null;
    }

    const listingFeatures = getListingFeatures(features);

    return (
        // eslint-disable-next-line jsx-a11y/no-redundant-roles
        <ul
            role="list"
            className={featureListStyle({ noSpacing })}
            data-name="feature-list"
        >
            {listingFeatures?.map((item, idx) => {
                const { iconId: featureId, content } = item ?? {};

                const icon = featureMap.get(featureId || '');

                if (!icon) {
                    return null;
                }

                return (
                    <li
                        className={featureListItemStyle}
                        key={`${featureId}-${idx}`}
                        data-testid={`${featureId}-feature`}
                    >
                        {icon}
                        <span className={fontGroups.knife}>{content}</span>
                    </li>
                );
            })}
        </ul>
    );
};

export default ListingFeatureList;
